import React from 'react';
import { Query } from '../../utils';
import { Page, ListGroup, Row, Container, Button, Table, Form, Spinner } from '../../components';
import DataTable from '../../components/data-table.js';
import sprintf from 'yow/sprintf';

export default class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.state.loading = true;
		this.state.result = 'OK';
		this.state.stocks = null;
		this.state.filter = '';
		this.state.helpText = '';
		this.state.selection = [];

		this.list = React.createRef();

		this.radioClick = this.radioClick.bind(this);
		this.onSelectionChange = this.onSelectionChange.bind(this);
	}

	getColumns(query) {
		let columns = [];

		for (const key in query[0]) {
			columns.push(key);
		}

		return columns;
	}

	async fetch() {
		try {
			let query = new Query();
			let stocks = await query.fetch('SELECT * FROM stocks LIMIT 50');

			this.setState({ stocks: stocks, loading: false });
		} catch (error) {
			this.setState({ result: error.message, loading: false });
		}
	}

	async componentDidMount() {
		await this.fetch();
	}

	onSelectionChange(rows) {
		console.log(rows);
		//        rows = [...rows.shift()];
		//        this.list.current.setState({rows:rows, sortBy:2});
	}
	radioClick(event) {
		//        event.preventDefault();
		//        event.stopPropagation();

		let target = event.target;
		let row = target.attributes['row'].value;
		//                debugger;
		//console.log(event.target.attributes['foo'].value);
		console.log(target.checked);

		console.log(this.state.stocks[parseInt(row)]);

		this.setState({ selection: [12] });
	}

	renderTable() {
		let columns = [
			{
				id: 'symbol',
				title: 'Ticker',
			},
			{
				id: 'name',
				title: 'Namn',
			},
			{
				id: 'close',
				title: 'Kurs',
				className: 'text-end',
				format: (row) => (row.close ? row.close.toLocaleString() : '-'),
			},

			{
				title: (row, index) => <input type='checkbox' disabled className='form-check-input'></input>,
				align: 'center',
				content: (row, index) => <input row={index} type='checkbox' className='form-check-input' checked={this.state.selection[index]} onChange={this.radioClick}></input>,
			},
		];

		return (
			<>
				<div>
					<DataTable ref={this.list} selectionStyle='multiple' onSelectionChange={this.onSelectionChange} rows={this.state.stocks} columns={columns}></DataTable>
				</div>
			</>
		);
	}

	renderSpinner() {
		let style = {};
		style.marginLeft = 'auto';
		style.marginRight = 'auto';
		style.display = 'flex';
		style.alignItems = 'center';

		return <Spinner style={style} animation='grow' />;
	}

	render() {
		if (this.state.stocks == null) {
			return <Page>{this.renderSpinner()}</Page>;
		}
		let style = {};
		style.overflowY = 'scroll';
		style.height = '20em';
		//style.margin = '2em';
		style.border = '1px solid red';

		let renderMutedText = () => {
			if (this.state.filter.length > 0) {
				return (
					<Form.Text className='mt-3' muted>
						Visar det som matchar <strong>{this.state.filter}.</strong>
					</Form.Text>
				);
			}
			return (
				<Form.Text className='' muted>
					Hittade {this.state.stocks.length} tickers. Filtrera med snabbfiltret.
				</Form.Text>
			);
		};

		return (
			<Page>
				{this.renderTable()}
				<Button link={-1}>Tillbaka</Button>
			</Page>
		);

		return (
			<Page>
				<div style={style} className='mb-1'>
					{this.renderTable()}
				</div>
				<Button link={-1}>Tillbaka</Button>
			</Page>
		);
	}
}
